import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/upload`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.baseUrl}/upload/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.baseUrl}/upload/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/upload`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.baseUrl}/upload/`+Id);
    }

}
